import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
  },
  radioError: {
    color: theme.palette.error.main,
    '& *': {
      color: theme.palette.error.main,
    },
  },
  span: {
    lineHeight: 'normal',
  },
}))

export default styles
